export const HOME_WIDGET_OPTIONS = [
  { key: "liveMatches", label: "Live Matches" },
  { key: "table", label: "League Table" },
  { key: "deadlines", label: "Deadlines" },
  { key: "fixtures", label: "Fixtures" },
];

export const DEFAULT_HOME_WIDGETS = HOME_WIDGET_OPTIONS.map((w) => w.key);
